import type { ResultRevisions } from '../services/api';

/** Opaque publication revisions change only when a result or asset changes. */
export function resultRevisionKey(revisions: ResultRevisions | undefined, fields: Array<keyof ResultRevisions> = ['metadata', 'segments', 'video_level', 'assets']) {
  return JSON.stringify(fields.map((field) => revisions?.[field] ?? null));
}
